"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.address = exports.decimalToBalance = exports.formatToDecimals = exports.balanceToDecimal = void 0;
const utils_1 = require("ethers/lib/utils");
function balanceToDecimal(s) {
    return (0, utils_1.formatUnits)(s);
}
exports.balanceToDecimal = balanceToDecimal;
function formatToDecimals(n, decimals = 2) {
    if (n === null || n === undefined || isNaN(n))
        return "-";
    if (n == Infinity)
        return "Infinity"; //return "∞";
    return (Math.round(n * (Math.pow(10, decimals))) / (Math.pow(10, decimals))).toFixed(decimals);
}
exports.formatToDecimals = formatToDecimals;
function decimalToBalance(d, decimals = 18) {
    const n = parseFloat(d.toString());
    const s = formatToDecimals(Math.max(n, 0), decimals);
    return (0, utils_1.parseUnits)(s, decimals);
}
exports.decimalToBalance = decimalToBalance;
function address(n) {
    return `0x${n.toString(16).padStart(40, '0')}`;
}
exports.address = address;
